module.exports = __webpack_public_path__ + "media/images/BIIMainlogo-8db4f836.png";